module.exports = __webpack_public_path__ + "static/media/27.f9481829.png";